import React, { useState, useReducer, useEffect } from 'react';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import InfoIcon from '@mui/icons-material/Info';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import { fetchAllInRoomDining, inRoomDiningAddOnSelector } from '../../../servicesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { FormControlLabel, Radio, RadioGroup, Button, IconButton } from '@material-ui/core';
import { formDataValidate, VALID_INTEGER } from '../../../../../utils/formUtils';
import { addInRoomDiningAddOn } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import AddNewPopUPModel from '../../../../../shared/add-new-popup/Add-New-Popup-Model';
import CustomChipInput from './../../../../../shared/form-controls/custom-chip-input/Custom-Chip-Input';
import EditIcon from '@mui/icons-material/Edit';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const ItemCreateAddons = (props) => {
  const {
    formData,
    addOnError,
    setAddOnError,
    setFormData,
    onChangeRadioButton,
    hotelId,
    restaurantId,
    setValidLimit,
    validLimit,
    groupAddon,
    setGroupAddon,
    showLoader = () => {},
  } = props;
  const originalAddons = useSelector(inRoomDiningAddOnSelector);
  const [isEditGroupedAddon, setIsEditGroupedAddon] = useState({
    isEdit: false,
    customIndex: -1,
  });
  const [addNewValues, setAddNewValues] = useState({
    title: '',
    status: false,
  });
  const dispatch = useDispatch();
  const activeAddons = originalAddons?.filter((item) => item?.status === true);
  const activeAddonIds = React.useMemo(
    () => new Set(activeAddons.map((a) => a.id)),
    [activeAddons],
  );

  useEffect(() => {
    // setGroupAddon();
    const filteredGroupedAddons = formData.groupedAddon.value.filter((group) =>
      group.addons.every((addon) => activeAddonIds.has(addon)),
    );
    setGroupAddon(filteredGroupedAddons);
  }, []);

  const [addonsFormData, setAddonsFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Add-on Name',
        errors: {},
        validations: ['required'],
      },
      code: {
        value: '',
        fieldName: 'Addon Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
      },
      price: {
        value: '',
        fieldName: 'Price',
        errors: {},
        validations: ['required'],
      },
      status: {
        value: true,
        fieldName: 'Active',
        errors: {},
        validations: [],
      },
    },
  );

  const renderModelAddons = () => {
    return (
      <div>
        <div className='mx-4'>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.name}
              handleInputChange={(e) => {
                setAddonsFormData({ name: e });
              }}
              maxLength={60}
              endAdornment={true}
              characterCount={true}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.code}
              handleInputChange={(e) => {
                setAddonsFormData({ code: e });
              }}
              maxLength={50}
              endAdornment={true}
              characterCount={true}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.price}
              handleInputChange={(e) => {
                setAddonsFormData({ price: e });
              }}
              type='number'
              min={0}
              max={99999999}
            />
          </div>
        </div>
      </div>
    );
  };

  const validateAddonsFormData = () => {
    const updatedFields = {};
    const isValid = formDataValidate(addonsFormData, updatedFields);
    setAddonsFormData(updatedFields);
    return isValid;
  };

  const onCLickAddAddons = async () => {
    if (hotelId && validateAddonsFormData()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          name: addonsFormData?.name?.value,
          code: addonsFormData?.code?.value,
          price: Math.floor(parseFloat(addonsFormData?.price?.value) || 0),
          priceInDecimal: parseFloat(addonsFormData?.price?.value) || 0,
          status: addonsFormData?.status?.value,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        const resp = await addInRoomDiningAddOn(payload, language);
        const addonsIdFormData = formData?.addonsId;
        const updatedAddonId = [...addonsIdFormData.value, resp?.data?.createIRDAddon?.id];
        addonsIdFormData.value = [...updatedAddonId];
        setFormData({ groupAddonsId: addonsIdFormData });
        notificationManager('success', 'Add-ons created successfully');
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        formData.addonsId.errors = { required: null };
        if (formData?.addonsStatus?.value === 'grouped') {
          formData.addonsId.validations = ['required'];
        }
        handlePopupClose();
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          notificationManager('danger', 'Add-ons creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
      handlePopupClose();
    }
  };

  useEffect(() => {
    if (formData.addonsStatus.value === 'grouped') {
      const allGroupedInActive =
        groupAddon.length > 0 &&
        groupAddon.every((group) => group.addons.every((addon) => activeAddonIds.has(addon)));

      setValidLimit(!allGroupedInActive);
    } else if (
      formData?.addonsLimitStatus?.value === 'active' &&
      formData?.addonsId?.value?.length > 0 &&
      formData?.addonsMaxLimit?.value
    ) {
      const selectedActiveAddonsCount = formData?.addonsId?.value?.filter((id) =>
        activeAddons.some((addon) => addon.id === id),
      ).length;
      const exceedsLimit = selectedActiveAddonsCount < formData?.addonsMaxLimit?.value;
      setValidLimit(exceedsLimit && selectedActiveAddonsCount > 0);
    } else {
      setValidLimit(false);
    }
  }, [
    formData.addonsStatus.value,
    formData?.addonsId?.value,
    formData?.addonsLimitStatus?.value,
    formData?.addonsMaxLimit?.value,
    groupAddon,
    activeAddons,
    activeAddonIds,
    setValidLimit,
  ]);

  const openAddonsModal = (textFieldValue) => {
    setAddNewValues({
      title: 'Add-on',
      status: true,
    });
    const nameFieldAddonsFormData = { ...addonsFormData.name };
    const priceFieldAddonsFormData = { ...addonsFormData.price };
    nameFieldAddonsFormData.value = textFieldValue;
    priceFieldAddonsFormData.value = '';
    setAddonsFormData({
      name: nameFieldAddonsFormData,
      price: priceFieldAddonsFormData,
    });
  };

  const handlePopupClose = () => {
    setAddNewValues({
      title: '',
      status: false,
    });
    const resetAddonsFormData = { ...addonsFormData };
    resetAddonsFormData.name.value = '';
    resetAddonsFormData.code.value = '';
    resetAddonsFormData.price.value = 0;
    setAddonsFormData(resetAddonsFormData);
  };

  const onChangeAddonStatus = (e, fieldName) => {
    setAddOnError(false);
    formData.addonsMaxLimit.value = [];
    formData.groupTitle.value = '';
    formData.groupTitle.validations = [];
    formData.addonsId.validations = [];
    formData.addonsId.value = [];
    formData.groupedAddon.validations = [];
    formData.groupedAddon.value = [];
    formData.addonsMaxLimit.validations = [];
    if (e.target.value === 'inactive') {
      formData.addonsLimitStatus.value = 'inactive';
    } else if (e.target.value === 'grouped') {
      formData.groupTitle.validations = ['required'];
      formData.groupedAddon.validations = ['required'];
      formData.addonsId.validations = ['required'];
    } else {
      formData.addonsMaxLimit.validations = ['required', 'positiveOnly', VALID_INTEGER];
      formData.addonsLimitStatus.value = 'active';
      formData.addonsId.validations = ['required'];
    }
    setGroupAddon(formData.groupedAddon.value);
    onChangeRadioButton(e, fieldName);
  };

  const onChangeAddonLimitStatus = (e, fieldName) => {
    formData.addonsMaxLimit.validations =
      e.target.value === 'active' ? ['required', 'positiveOnly', VALID_INTEGER] : [];
    onChangeRadioButton(e, fieldName);
  };

  const onDeleteGroup = (e, index) => {
    e.preventDefault();
    const currField = { ...formData.groupedAddon };
    const cstm = [...currField.value];
    setGroupAddon(cstm);
    cstm.splice(index, 1);
    currField.value = cstm;
    setFormData({ groupedAddon: currField });
  };

  const onAddGroupedAddons = () => {
    const filterActiveAddonIds = (ids) => ids?.filter((id) => activeAddonIds?.has(id));
    const filterGroupsWithActiveAddons = (groups) =>
      groups
        ?.map((g) => ({ ...g, addons: filterActiveAddonIds(g?.addons) }))
        ?.filter((group) => group?.addons?.length);
    const title = formData?.groupTitle?.value;
    const limit = formData?.groupAddonsMaxLimit?.value;
    const addons = filterActiveAddonIds(formData?.groupAddonsId?.value);
    if (title && limit && addons?.length > 0) {
      setAddOnError(false);
      const currentInput = {
        title,
        limit,
        addons,
      };
      if (isEditGroupedAddon.isEdit) {
        const currField = { ...formData.groupedAddon };
        const addOnData = filterGroupsWithActiveAddons([...currField.value]);
        addOnData[isEditGroupedAddon.customIndex] = currentInput;
        currField.value = addOnData;
        setGroupAddon(addOnData);
        setFormData({ groupedAddon: currField });
        setIsEditGroupedAddon({ isEdit: false, customIndex: -1 });
      } else {
        const currField = { ...formData.groupedAddon };
        const validGroupedAddons = filterGroupsWithActiveAddons(currField.value);
        const itemIndex = validGroupedAddons.findIndex((grp) => grp.name === title);
        if (itemIndex === -1) {
          const addOnData = [...validGroupedAddons, currentInput];
          setGroupAddon(addOnData);
          currField.value = addOnData;
          setFormData({ groupedAddon: currField });
        } else {
          const addOnData = [...validGroupedAddons];
          addOnData[itemIndex] = currentInput;
          setGroupAddon(addOnData);
          currField.value = addOnData;
          setFormData({ groupedAddon: currField });
        }
      }
      formData.groupTitle.value = '';
      formData.groupAddonsMaxLimit.value = '';
      formData.groupAddonsId.value = [];
      formData.addonsId.validations = [];
      if (formData.addonsStatus.value === 'grouped') {
        formData.addonsId.validations = ['required'];
      }
    }
  };

  const getAddonForGroup = (addonForGroup) => {
    const addonArray = originalAddons.filter((addon) => {
      return addonForGroup.includes(addon.id);
    });
    return (
      <div className='row d-inline-flex'>
        {addonArray
          .map((item) => {
            return item.name;
          })
          .join(', ')}
      </div>
    );
  };

  const onClickEditGroup = async (e, key, index) => {
    e.preventDefault();
    setIsEditGroupedAddon({ isEdit: true, customIndex: index });
    formData.groupTitle.value = key.title;
    formData.groupAddonsMaxLimit.value = key.limit;
    formData.groupAddonsId.value = key.addons;
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4'>
      {addNewValues && addNewValues.status === true && (
        <AddNewPopUPModel
          addNewPopUp={addNewValues}
          onClickAdd={onCLickAddAddons}
          onClickCancel={handlePopupClose}
          renderModel={renderModelAddons}
          formData={addonsFormData}
        />
      )}
      <div className='row'>
        <h4 className='tab-title'>Add-ons</h4>
        <div className='col-md-12 mb-3'>
          <RadioGroup
            row
            aria-label={formData.addonsStatus.fieldName}
            onChange={(e) => {
              onChangeAddonStatus(e, 'addonsStatus');
            }}
            value={formData.addonsStatus.value}
            name={formData.addonsStatus.fieldName}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='grouped'
              control={<Radio color='primary' />}
              label='Grouped'
              className='col-md-3'
            />
            <FormControlLabel
              value='active'
              control={<Radio color='primary' />}
              label='Ungrouped'
              className='col-md-3'
            />
            <FormControlLabel
              value='inactive'
              control={<Radio color='primary' />}
              label='Inactive'
              className='col-md-3'
            />
          </RadioGroup>
        </div>
      </div>
      {formData.addonsStatus.value === 'grouped' && (
        <div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.groupTitle}
                handleInputChange={(e) => {
                  setFormData({ groupTitle: e });
                }}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.groupAddonsMaxLimit}
                handleInputChange={(e) => {
                  setFormData({ groupAddonsMaxLimit: e });
                }}
                type='number'
                min={0}
                max={100}
              />
            </div>
          </div>
          <div className='row mb-3'>
            <CustomChipInput
              options={activeAddons}
              labelField='name'
              textFieldLabel='Add-ons'
              textFieldPlaceholder='Select Add-ons'
              isAddNewEnabled={true}
              onClickAddNew={openAddonsModal}
              formData={formData}
              setFormData={setFormData}
              formField='groupAddonsId'
            />
          </div>
          <div className='me-3 col-md-4 row mt-2 mb-2'>
            <Button
              variant='outlined'
              color='primary'
              disabled={
                !formData.groupTitle.value ||
                !formData.groupAddonsMaxLimit.value ||
                !formData.groupAddonsId.value ||
                formData.groupAddonsId.value.length < formData.groupAddonsMaxLimit.value
              }
              onClick={onAddGroupedAddons}
              size='large'
              className='me-3 col-md-4'
            >
              Add
            </Button>
          </div>
          {addOnError && formData.groupedAddon.value.length === 0 && (
            <p style={{ color: 'red' }}>Grouped Addon is required</p>
          )}
          {groupAddon && groupAddon.length > 0 && (
            <div className='col-md-12 mt-3'>
              {groupAddon.map((groupKey, groupIndex) => (
                <div
                  className='row details-value d-flex mt-2 mb-2 customDisplay p-1'
                  key={groupIndex}
                >
                  <div className='col-md-10 ml-2'>
                    <span className='ingredientName'>
                      {groupKey.title} ({groupKey.limit}):{' '}
                    </span>
                    <span> {getAddonForGroup(groupKey.addons)}</span>
                  </div>
                  <div className='col-md-1'>
                    <IconButton
                      aria-label='edit'
                      onClick={(e) => onClickEditGroup(e, groupKey, groupIndex)}
                    >
                      <EditIcon fontSize='12' className='icon' />
                    </IconButton>
                  </div>
                  <div className='col-md-1'>
                    <IconButton aria-label='delete' onClick={(e) => onDeleteGroup(e, groupIndex)}>
                      <RemoveCircleIcon fontSize='12' className='icon' />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {formData.addonsStatus.value === 'active' && (
        <div>
          <div className='row'>
            <div className='row info-icon col-md-6'>
              <div className='col-md-3 mr-3'>
                <h4 className='tab-title'>Limit</h4>
              </div>
              <div className='col-md-3'>
                <CustomToolTip
                  title='Number of add-ons user can select among the options'
                  placement='right-end'
                >
                  <InfoIcon fontSize='small' />
                </CustomToolTip>
              </div>
            </div>
            <div className='col-md-12 mb-3'>
              <RadioGroup
                row
                aria-label={formData.addonsLimitStatus.fieldName}
                onChange={(e) => {
                  onChangeAddonLimitStatus(e, 'addonsLimitStatus');
                }}
                value={formData.addonsLimitStatus.value}
                name={formData.addonsLimitStatus.fieldName}
                className='document-type mb-3'
              >
                <FormControlLabel
                  value='active'
                  control={<Radio color='primary' />}
                  label='Active'
                  className='col-md-4'
                />
                <FormControlLabel
                  value='inactive'
                  control={<Radio color='primary' />}
                  label='Inactive'
                  className='col-md-4'
                />
              </RadioGroup>
            </div>
          </div>
          {formData.addonsLimitStatus.value === 'active' && (
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.addonsMaxLimit}
                handleInputChange={(e) => {
                  setFormData({ addonsMaxLimit: e });
                }}
                type='number'
                min={0}
                max={100}
              />
            </div>
          )}
          <div className='row mb-3'>
            <CustomChipInput
              options={activeAddons}
              labelField='name'
              textFieldLabel='Add-ons'
              textFieldPlaceholder='Select Add-ons'
              isAddNewEnabled={true}
              onClickAddNew={openAddonsModal}
              formData={formData}
              setFormData={setFormData}
              formField='addonsId'
            />
          </div>
          {validLimit && (
            <p className='field-error mt-2'>
              Add-Ons should be more than or equal to the maximum selection limit
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemCreateAddons;
